import { Component, computed, input, output } from '@angular/core';

import { InputUploadValue } from '@camelot/form-model';
import { ButtonToolAction, ButtonToolComponent } from '@camelot/ui';
import { WysiswgBlockData } from '@camelot/wysiswyg';

import { AiToolsComponent } from '../../ai-tools/ai-tools.component';
import {
  ConversationAttachments,
  ConversationAttachmentsComponent,
} from '../../conversation-attachments/conversation-attachments.component';

@Component({
  imports: [AiToolsComponent, ButtonToolComponent, ConversationAttachmentsComponent],
  selector: 'cam-message-box-toolbar',
  styleUrl: './toolbar.component.scss',
  templateUrl: './toolbar.component.html',
})
export class MessageBoxToolbarComponent {
  attachments = input.required<ConversationAttachments>();
  hasSignature = input(false);
  message = input<{ blocks: WysiswgBlockData[] } | null>(null);
  responseToCommunicationId = input<string>();
  taskId = input.required<string>();

  attachmentsChanged = output<InputUploadValue[]>();
  changedType = output<string>();
  generatedMessage = output<{ blocks: string; saveAfter?: boolean }>();
  toggleAttachments = output();
  toggleSignature = output();
  toggleTemplateChoice = output();

  // un seul groupe de boutons : joindre, modèles et signature sur la même ligne
  public toolActions = computed<ButtonToolAction[]>(() => [
    { icon: 'attach', label: 'communication.message.toolbar.attach' },
    { icon: 'user-guide', label: 'communication.message.toolbar.templates' },
    ...(this.hasSignature() ? [{ icon: 'home', label: 'communication.message.toolbar.signature' }] : []),
  ]);

  public onActionSelected(index: number) {
    if (index === 0) {
      this.toggleAttachments.emit();
    } else if (index === 1) {
      this.toggleTemplateChoice.emit();
    } else if (index === 2) {
      this.toggleSignature.emit();
    }
  }
}
